import React from "react";
import { Compass, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function NextBestActionCard({ actionText, onActionClick, ctaLabel = "Executar Agora", linkTo }) {
  return (
    <div
      data-testid="next-best-action-card"
      className="bg-gradient-to-r from-[#181B24] via-[#1F1D24] to-[#251A18] border-2 border-[#FF6B00]/40 rounded-xl p-4 shadow-[0_4px_24px_rgba(255,107,0,0.15)] relative overflow-hidden"
    >
      <div className="flex items-start gap-3.5">
        <div className="w-10 h-10 rounded-lg bg-[#FF6B00]/20 border border-[#FF6B00]/50 flex items-center justify-center shrink-0 text-[#FF6B00]">
          <Compass className="w-6 h-6 animate-pulse" />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-[11px] font-extrabold uppercase tracking-wider text-[#FF6B00] bg-[#FF6B00]/10 px-2 py-0.5 rounded border border-[#FF6B00]/20">
              🎯 Próxima Ação
            </span>
            <span className="text-[11px] text-gray-400">Recomendação do Mentor</span>
          </div>

          <p
            data-testid="next-action-text"
            className="text-base sm:text-lg font-bold text-white leading-snug mt-1"
          >
            {actionText || "Continue executando o checklist operacional do dia."}
          </p>

          <div className="mt-3 flex items-center gap-2">
            {linkTo ? (
              <Link
                to={linkTo}
                data-testid="next-action-cta-btn"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-[#FF6B00] hover:bg-[#FF8533] text-black font-extrabold text-xs uppercase tracking-wide transition-all shadow-[0_0_15px_rgba(255,107,0,0.4)]"
              >
                <span>{ctaLabel}</span>
                <ArrowRight className="w-3.5 h-3.5" />
              </Link>
            ) : onActionClick ? (
              <button
                data-testid="next-action-cta-btn"
                onClick={onActionClick}
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-[#FF6B00] hover:bg-[#FF8533] text-black font-extrabold text-xs uppercase tracking-wide transition-all shadow-[0_0_15px_rgba(255,107,0,0.4)]"
              >
                <span>{ctaLabel}</span>
                <ArrowRight className="w-3.5 h-3.5" />
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
